module.exports = __webpack_public_path__ + "assets/img/stores.5f2a4611.svg";